import utils from '../utils';
import Handlebars from 'handlebars';
import { ShopListingProductBlock } from './shopListingProductBlock';

const NS = 'ShopListingBlock';
const CLS = 'shopListingBlock';

export class ShopListingBlock {
	constructor(element) {
		// $el is the widget node return by the loadShopProductBlock function
		this.$el = $(element);
		this.$filterKeys = this.$el.find(`[data-filter-key]`);
		this.$filterDropdown = this.$el.find(`.${CLS}-filters-dropdown`);
		this.$filterDropdownMenu = this.$el.find(`.${CLS}-filters-dropdown-menu`);
		this.$searchResultsEmpty = this.$el.find(`.${CLS}-searchResults-empty`);
		this.$shopProducts = this.$el.find(`.${CLS}-products`);
		this.$loadingScreen = this.$el.find(`.${CLS}-searchResults-loadingScreen`);
		this.$loadMore = this.$el.find(`.${CLS}-searchResults-loadMore`);
		this.$searchInp = this.$el.find(`.${CLS}-searchInput`);
		this.$clearFilterBtn = this.$el.find(`.${CLS}-filterBtnClear`);
		this.$certifiedContents = this.$el.find(`.${CLS}-certified-contents`);
		this.$cateContents = this.$el.find(`.${CLS}-cate-contents`);
		this.$cateContentsTitle = this.$el.find(`.${CLS}-cate-contents-title`);
		this.$cateContentsDescription = this.$el.find(`.${CLS}-cate-contents-description`);
		this.$cateCertifiedTitle = this.$el.find(`.${CLS}-certified-contents-title`);
		this.$cateCertifiedDescription = this.$el.find(`.${CLS}-certified-contents-description`);
		this.$typeSelectpick = this.$el.find( `#productType` );

		this.$keyword = this.$el.find(`.search .${CLS}-searchInput`);

		this.getProductsApi = this.$el.data('productsApi');
		this.getAllTypes = this.$el.find(`.type`).data('allTypes');
		this.loadingProducts = false;
		this.allProductsLoaded = false;
		this.pageSize = 12;
		this.pageNumber = 1;
		this.$productBlock = [];
		this.$productTypes = [];
		this.$urlcategoryArr = [];

		//----- Retrive the parameter values from the URL for dropdown menu if URL has default value ------//
		var url_string = window.location.href; 
		var url = new URL(url_string);

		this.$urlkeyword = url.searchParams.get("keyword");
		if(this.$urlkeyword){
			if(this.$urlkeyword.length > 0){
				this.$keyword.val(this.$urlkeyword);
			}
		}
		this.$urlcategory = url.searchParams.get("category");

		this.$urltype = url.searchParams.get("type");

		this.$isCertified = url.searchParams.get("isCertified");


		//----- End for retrive the parameter values from the URL-----//

		this.initParams();
		$('.selectpicker').selectpicker('destroy').selectpicker();
		this.handleSearchInput();
		this.handleFilterClearBtn(this.getAllTypes);
		this.handleScrollLoading();
		this.getItems(false);
		this.initFilterKeys();
		
	}

	initParams(clear){
		// for clear btn - if user clear the filter everthing needs to be empty
		if(clear){
			this.params = {
				// siteId: this.siteId,
				count: this.pageSize,
				offset: 0,
				keyword: '',
				category: '',
				type: '',
				isCertified: ''
			};
		}
		// for initial parameter values when page loads
		else{
			this.params = {
				// siteId: this.siteId,
				count: this.pageSize,
				offset: 0,
				keyword: this.$urlkeyword || '',
				category: this.$urlcategory || '',
				type: this.$urltype || '',
				isCertified: this.$isCertified || ''
			};
		}
	}

	// individual product template
	getShopListingProductBlockTemplate() {
		let shopListingProductBlock = require('../../partials/widgets/shopListingProductBlock.hbs');
		Handlebars.registerPartial('shopListingProductBlock', shopListingProductBlock);

		let template = `
			{{> shopListingProductBlock
				wg="shopListingProductBlock"
				ns="ShopListingProductBlock"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		return Handlebars.template(precompiled);
	}

	// Get items (reload content)
	getItems(loadMoreProducts) {
		// Check if all the products have been loaded
		if (!this.loadingProducts && !this.allProductsLoaded) {
			this.loadingProducts = true;

			let url = this.getProductsApi;
			
			if (loadMoreProducts) {
				this.setPageNumber(this.pageNumber + 1);
				this.$loadMore.addClass('active');
			} else {
				this.$loadingScreen.addClass('active');
			}
			// if parameter is not empty, then append to the API url
			if (!_.isEmpty(this.params)) {
				url += `?${$.param(this.params)}`;
			}
			
			// For display the products category, *but this may not the best practice to code this function.
			if(!this.params.isCertified || this.params.isCertified == "false" && !this.params.category){
				this.$cateContents.css("display", "none");
			}
			
			if(this.params.category){
				let newCategory=(this.params.category.toLowerCase()).replace( /\W/g, "");
				this.$cateContents.css("display", "none");
				$("."+newCategory).css("display", "flex");
			}
			else{
				if(this.params.isCertified =="true"){
					this.$cateContents.css("display", "none");
					$(".woolmarkcertified").css("display", "flex");
				}
			}
			// End for display the products category

			this.updateUrl();

			// ajax load products data
			$.ajax({
				type: 'GET',
				url: url,
				success: (data) => {
					this.$searchResultsEmpty.hide();

					// Check if this is the new search, if so empty previous products in the products div
					if (!loadMoreProducts) {
						this.$shopProducts.empty();
					}

					//check if has any data from the API, if so, append the data into the product template.
					if (data.length > 0) {
						data.forEach((item) => {
							let $column = this.$shopProducts.append(this.getShopListingProductBlockTemplate()(item));
							new ShopListingProductBlock($column.find(`[data-wg="ShopListingProductBlock"]`).last()[0], item);
						});
					} else {
						if (loadMoreProducts) {
							this.allProductsLoaded = true;
						} else {
							this.$searchResultsEmpty.show();
						}
					}

					this.$loadingScreen.removeClass('active');
					this.$loadMore.removeClass('active');
				},
				error: (error) => {

				},
				complete: () => {
					this.loadingProducts = false;
				},
			});
		}
	}

	// Update url after filters change
	updateUrl() {
		let uri = document.location.pathname;
		
		Object.keys(this.params).forEach((key, index) => {
			uri = utils.updateQueryStringParameter(uri, key, encodeURIComponent(this.params[key]));
		});

		// update url without reload
		window.history.pushState('', '', uri);
		let urlParams = new URLSearchParams(uri);

		// get product type parameter from url
		let type = urlParams.get('type');
		// if has type, then display the product type in the dropdown menu
		if(this.$urltype && this.$urltype.length){
			this.$typeSelectpick.selectpicker('refresh');
		}

	}

	// Search text input - on type
	handleSearchInput() {
		this.$searchInp.on('keyup', (event) => {
			if(event.keyCode === 13) {
				this.params['keyword'] = $(event.currentTarget).val().trim();
				this.setPageNumber(1);
				this.allProductsLoaded = false;
				this.getItems(false);
			}
		});
	}

	// Clear button
	handleFilterClearBtn(getAllTypes) {
		this.$clearFilterBtn.on('click', () => {
			this.filterTypeByCategory(getAllTypes);
			// set 1 to let initParams know it's coming from clear btn
			this.initParams(1);
			this.setPageNumber(1);
			this.allProductsLoaded = false;
			// Scroll to top
			window.scrollTo(0, 0);
			$(".selectpicker").selectpicker('deselectAll');
			$('#isCertified').selectpicker('val', '');
			this.$typeSelectpick.selectpicker('val', '');
			this.$typeSelectpick.selectpicker('refresh');
			this.getItems(false);
			
		});
	}

	filterTypeByCategory(types) {
		if (!types) {
			return;
		}
		const typeArr = types.split(";");
		// remove all
		$( "#productType .dropdown-item" ).remove();

		for(var i = 0; i < typeArr.length; i++){
			this.$typeSelectpick.append( '<option class="shopListingBlock-filters-dropdown-item dropdown-item" value="' + typeArr[i] +'">' + typeArr[i] + '</option>' );
		}

		setTimeout(() => {
		this.$typeSelectpick.selectpicker('refresh');
		}, 1000);

		this.filterTypeByType();
	}

	// Let product type clickable(update the URL) after selected the category or clear all the filters
	filterTypeByType() {
		const $typeFilterKeys = this.$el.find(`[data-filter-key="type"]`);
			$typeFilterKeys.on('change', (event) => {
			let $element = $(event.currentTarget);
			this.handleFilterClick($element);
		});
	}

	handleFilterClick($element) {
		let filterKey = $element.data('filterKey') || '';
		let value = [];
		value.push($element.val());
		this.$el.find(`[data-filter-key="${filterKey}"]`).removeClass('active');
		$element.addClass('active');

		if(!(_.isNil(this.params[filterKey]) && value === '')) {
			// Ensure that the filterKey does not match the current select value
			if(this.params[filterKey] !== value) {
				if(_.isNil(value) || value === '') {
					delete this.params[filterKey];
				}
				else {
					this.params[filterKey] = value.toString();
				}
				this.setPageNumber(1);
				this.allProductsLoaded = false;
				this.getItems(false);
			}
		}
	}

	// initialise the filter keys
	initFilterKeys() {

		this.$filterKeys.on('change', (event) => {
			this.stringProductTypes = [];
			let $element = $(event.currentTarget);
			let filterKey = $element.data('filterKey') || '';

			// user selected category, then clear product type
			if (filterKey === "category") {
				this.$productTypes = $("select :selected").map((i, $element) => $($element).attr("data-types")).toArray();
				this.$productTypes.forEach((element) => this.stringProductTypes.push(element.split(";")));
				this.stringProductTypes = this.stringProductTypes.flat();
				this.stringProductTypes = this.stringProductTypes.filter((item,
					index) => this.stringProductTypes.indexOf(item) === index);
				this.stringProductTypes = this.stringProductTypes.filter(Boolean).sort();
				if(this.stringProductTypes.includes("Other")){
					const index = this.stringProductTypes.indexOf("Other");
					this.stringProductTypes.splice(index, 1);
					this.stringProductTypes.push("Other");
				}
				this.stringProductTypes = this.stringProductTypes.join(',').replace(/,/g, ';');
				this.filterTypeByCategory(this.stringProductTypes);
				if (this.params["type"]) {
					delete this.params["type"];
				}
			}

			this.handleFilterClick($element);
		});
		
		// check url parameter contains the category.
		if(this.$urlcategory && this.$urlcategory.length){
			this.stringProductTypes = [];
			this.$urlcategoryArr = this.$urlcategory.split(",");
			$('#category').selectpicker('val', this.$urlcategoryArr);
			this.$productTypes = $("select :selected").map((i, $element) => $($element).attr("data-types")).toArray();
			this.$productTypes.forEach((element) => this.stringProductTypes.push(element.split(";")));
			this.stringProductTypes = this.stringProductTypes.flat();
			this.stringProductTypes = this.stringProductTypes.filter((item, index) => this.stringProductTypes.indexOf(item) === index);
			this.stringProductTypes = this.stringProductTypes.filter(Boolean).sort();
				if(this.stringProductTypes.includes("Other")){
					const index = this.stringProductTypes.indexOf("Other");
					this.stringProductTypes.splice(index, 1);
					this.stringProductTypes.push("Other");
				}
			this.stringProductTypes = this.stringProductTypes.join(',').replace(/,/g, ';');
			this.filterTypeByCategory(this.stringProductTypes);
		}

	}

	handleScrollLoading() {
		// when scroll to buttom before 200px, page will trigger the load more function.
		let offsetFromBottom = 200;
		const This = this;
		$(document).on('touchmove', onScroll); // for mobile
		function onScroll() {
			if ($(window).scrollTop() + offsetFromBottom > $(document).height() - $(window).height()-400) {
				This.getItems(true);
			}
		}
		$(window).scroll(function() {
			let position = $(window).scrollTop() + offsetFromBottom;
			let bottom = $(document).height() - $(window).height();

			if ( position >= bottom ) {
			   This.getItems(true);
			}
		 });
	}

	setPageNumber(newPageNumber) {
		this.pageNumber = newPageNumber;
		this.params.offset = (this.pageNumber - 1) * this.pageSize;
	}
}
